import axios from 'axios'
import store from '@/store/index'

// IP address of server
export const SERVER_IP = '127.0.0.1';

// Port Number of server
export const SERVER_PORT = 9546;

// server connection url
export const SERVER_URL = 'https://portal-backend.coi-csod.org/api/';

export default () => {
  return axios.create({
    baseURL: SERVER_URL + '',
    headers: {
      'Authorization': 'Bearer '+ store.state.auth.user.token,
      'Content-Type' : 'application/json'
    },
    // timeout: 3000
  })
}
